import { TermsCopy } from '@components/ui';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
export function ArbitrationSection(): JSX.Element {
  return (
    <>
      <Typography component="p" sx={{ textTransform: 'uppercase', fontWeight: 700, fontSize: 20, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.arbitration.0" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.arbitration.1" />
      </Typography>
      <Box sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.arbitration.2" />
        <Box component="ul" sx={{ mt: 1, mb: 0 }}>
          <li>
            <TermsCopy i18nKey="termsSections.arbitration.3" />
          </li>
          <li>
            <TermsCopy i18nKey="termsSections.arbitration.4" />
          </li>
          <li>
            <TermsCopy i18nKey="termsSections.arbitration.5" />
          </li>
          <li>
            <TermsCopy i18nKey="termsSections.arbitration.6" />
          </li>
          <li>
            <TermsCopy i18nKey="termsSections.arbitration.7" />
          </li>
          <li>
            <TermsCopy i18nKey="termsSections.arbitration.8" />
          </li>
        </Box>
      </Box>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.arbitration.9" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.arbitration.10" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.arbitration.11" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.arbitration.12" />
      </Typography>
    </>
  );
}
